<template>
  <a-modal :visible="visible" width="450px" :footer="null" @cancel="handleCloseModal">
    <div class="container__inactive">
      <img class="image__delete" :src="questionCircleUrl" alt="question" />
      <h1 class="text__alert">
        ¿Deseas cancelar la solicitud de {{ record?.channel_name }} del número
        {{ record?.associate }}?
      </h1>
    </div>
    <p class="text">Sucederá lo siguiente:</p>
    <ul>
      <li>La solicitud de WhatsApp Voice también se cancelerá, al estar asociado a un mismo número.</li>
      <li>La solicitud de WhatsApp Message y WhatsApp Voice serán eliminadas del registro.</li>
    </ul>

    <div class="button__disabled">
      <a-button
        style="width: 100%"
        type="primary"
        @click="fetchCancel"
      >
        Cancelar solicitud
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent } from "vue";
import { message } from "ant-design-vue";
import { ChannelType } from "@/app/shared/utils/enums";
import questionCircleUrl from "@/app/common/assets/question-circle.png?url";

export default defineComponent({
  name: "CancelChannel",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      questionCircleUrl,
    };
  },
  methods: {
    async fetchCancel() {
      try {
        console.log("cancelandochannelmultiple")
        await this.$store.dispatch("deleteChannel", this.record.id);
        this.showMessage();
      } catch (error) {
        console.error(error);
        const errorMessage = error?.getErrorMessage?.() || "Ha courrido un error";

        message.warning(errorMessage);
      }
    },
    showMessage() {
      if (this.record.channel_id === ChannelType.Whatsapp) {
        this.$message.success(
          `Se eliminó la solicitud de ${this.record.provider_name} asociado a ${this.record.associate}.`
        );
      }
      this.handleCloseModal();
    },
    handleCloseModal() {
      window.removeEventListener("message", this.listener, false);
      this.$emit("reloadTable");
      this.$emit("onClose");
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 18px
  font-weight: 600

.text
  margin-bottom: 20px

.button__disabled
  margin-top: 10px

.strong
  font-weight: 600

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center
</style>
